import { Component, OnInit, ViewChild, ElementRef, Renderer2, AfterViewInit } from '@angular/core';
import { SecurityService } from '../../core/services/security.service';
import { ComplaintModel } from '../../core/models/complaint/complaint.model';
import { DropdownItem } from '../../core/models/dropdown-item';
import { SharedService } from '../../shared/shared.service';
import { LanguageService } from '../../core/language/language.service';
import { CONFIG } from '../../core/config';
import { ToastService } from '../../core/toast/toast.service';
import { ComplaintsService } from '../complaints.service';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { Images } from '../../core/models/complaint/images';
import { UploadImageModel } from '../../core/models/complaint/upload-image.model';
import { SystemNotification } from '../../core/models/complaint/system-notification';
import { CategoryService } from '../../admin/global-codes/category/category.service';
import { Category } from '../../core/models/administration/global-codes/category';
import { SystemParametersService } from '../../admin/system-parameters/system-parameters.service';
import { ResizeImage } from '../../core/image/image-resizer';

declare var ol: any;

export class GPS {
    propLongitude: number;
    propLatitude: number;
    closeAddress: string;
}

export var gps = new GPS();

@Component({
    selector: 'app-report-problem',
    templateUrl: './report-problem.component.html'
})
export class ReportProblemComponent implements OnInit {
    public pathname: string;
    public currentUsername: string;
    public currentUserToken: string;
    public problem: ComplaintModel;
    public categories: DropdownItem[] = [];
    private languageID: number;
    public selectedFiles: File[] = [];
    public systemNotification: SystemNotification;

    public maxImages: number;
    public maxImageSize: number;

    @ViewChild('image') private image: ElementRef;

    map: any;

    constructor(private _securityService: SecurityService,
        private _sharedService: SharedService,
        private _languageService: LanguageService,
        private _toastService: ToastService,
        private _complaintsService: ComplaintsService,
        private _systemParametersService: SystemParametersService,
        private _renderer: Renderer2,
        private _router: Router) {
        this.languageID = this._languageService.selectedLanguageId;
        this.problem = new ComplaintModel();
        this.systemNotification = new SystemNotification();
        this._sharedService.getAllCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.categories = result;
        });
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this.currentUsername = this._securityService.getCurrentUsername();
        this.currentUserToken = this._securityService.token;

        this._systemParametersService.getComplaintParameterByID(CONFIG.complaintConfigurationEnum.Broj_slika_koje_se_mogu_dodati_kod_prijave_problema, this.languageID).subscribe(result => {
            this.maxImages = +result.value;
            //console.log(this.maxImages);
        });

        this._systemParametersService.getComplaintParameterByID(CONFIG.complaintConfigurationEnum.Velicina_slike_izrazena_u_KB_koje_se_moze_dodati_kod_prijave_problema, this.languageID).subscribe(result => {
            this.maxImageSize = +result.value;
            //console.log(this.maxImageSize);
        });

        this.initProblem();

        this.map = new ol.Map({
            target: 'map',
            controls: ol.control.defaults({
                attributionOptions: {
                    collapsible: false
                }
            }),
            layers: [
                new ol.layer.Tile({
                    source: new ol.source.OSM()
                })
            ],
            view: new ol.View({
                center: ol.proj.fromLonLat([CONFIG.coordinates.gpsx, CONFIG.coordinates.gpsy]),
                zoom: 12
            })
        });

        this.map.on('click', function (args) {
            var lonlat = ol.proj.transform(args.coordinate, 'EPSG:3857', 'EPSG:4326');

            var lon = lonlat[0];
            var lat = lonlat[1];

            const features = [];

            const longitude = lon;
            const latitude = lat;

            gps.propLongitude = longitude;
            gps.propLatitude = latitude;
            document.getElementById("latSpan").innerHTML = "Lat: " + latitude;
            document.getElementById("lonSpan").innerHTML = "Lon: " + longitude;


            // Create Reverse Geocoding url
            const data = { 'lat': latitude, 'lon': longitude };
            const ret = [];
            for (let d in data)
                ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
            var queryString = ret.join('&');
            var url = CONFIG.gpsAddressUrl;
            var completeUrl = url + queryString;

            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    var el = <HTMLInputElement>document.getElementById("problemLocationDescription");
                    if (this.responseXML.getElementsByTagName("result").length == 0)
                        gps.closeAddress = "";
                    else {
                        el.value = this.responseXML.getElementsByTagName("result")[0].textContent;
                        gps.closeAddress = this.responseXML.getElementsByTagName("result")[0].textContent;
                    }
                }
            };
            xhttp.open("GET", completeUrl, true);
            xhttp.send();

            var emit: BehaviorSubject<GPS> = new BehaviorSubject<GPS>(null);
            var emitter: Observable<GPS> = new Observable<GPS>(() => { emit.next(gps); });

            const iconFeature = new ol.Feature({
                geometry: new ol.geom.Point(ol.proj.transform([longitude, latitude], 'EPSG:4326', 'EPSG:3857'))
            });

            const iconStyle = new ol.style.Style({
                image: new ol.style.Icon(({
                    anchor: [0.5, 1],
                    src: 'http://cdn.mapmarker.io/api/v1/pin?text=P&size=40&hoffset=1'
                }))
            });

            iconFeature.setStyle(iconStyle);
            features.push(iconFeature);

            const vectorSource = new ol.source.Vector({
                features: features
            });

            const markerVectorLayer = new ol.layer.Vector({
                source: vectorSource,
            });

            this.removeLayer(this.previousLayer)
            this.previousLayer = markerVectorLayer;
            this.addLayer(markerVectorLayer);
        });
    }

    initProblem() {
        this.problem.title = null;
        this.problem.description = null;
        this.problem.categoryID = null;
        this.problem.gpsx = null;
        this.problem.gpsy = null;
    }
    
    onSubmit() {
        this.systemNotification.systemNotificationId = 1;
        this.problem.gpsx = gps.propLongitude;
        this.problem.gpsy = gps.propLatitude;
        this.problem.locationDescription = gps.closeAddress;

        const formData = new FormData();
        Array.from(this.selectedFiles).map((file, index) => {
            return formData.append('file' + index, file, file.name);
        });
        formData.append('data', JSON.stringify(this.problem));

        this._complaintsService.reportProblem(formData).subscribe(res => {
            if (res.id > 0) {
                this.finish();
            }
        });
    }

    onSelectedFile(event) {
        //console.log(event.target.files[0]);
        //console.log(this.maxImageSize);
        if (event.target.files.length > 0) {
            let complaintImage = event.target.files[0];

            if (complaintImage.size / 1024 <= this.maxImageSize) {

                ResizeImage(event.target.files[0], CONFIG.imageMaxSizeInPixels.complaintImageMagnifie).then(blob => {
                    complaintImage = new File([blob], event.target.files[0].name);
                    let reader = new FileReader();

                    this.readFile(complaintImage, reader, (result: any) => {
                        this.selectedFiles.push(<File>complaintImage);

                        const li: HTMLLIElement = this._renderer.createElement('li');
                        const img: HTMLImageElement = this._renderer.createElement('img');
                        img.src = result;
                        this._renderer.addClass(img, 'complaint-image');

                        const a: HTMLAnchorElement = this._renderer.createElement('a');
                        a.innerText = this._languageService.instant('Obrisi');
                        a.addEventListener("click", () => {
                            this.deleteImage(complaintImage, li);
                        });
                        this._renderer.addClass(a, 'delete-btn');

                        this._renderer.appendChild(li, a);
                        this._renderer.appendChild(this.image.nativeElement, li);
                        this._renderer.appendChild(li, img);
                    });
                    
                }, err => {
                    console.error("Greška učitavanja slike!", err);
                });                
            } else {
                -
                this._toastService.activate(this._languageService.instant('max_velicina_slike') + ' ' + this.maxImageSize + ' KB', 'alert-dangerToast');
            }
        }
    }

    readFile(file: File, reader: any, callback: any) {
        reader.onload = () => {
            callback(reader.result);
        }
        reader.readAsDataURL(file);
    }

    deleteImage(complaintImage: File, li: HTMLLIElement) {
        this.selectedFiles = this.selectedFiles.filter(x => x.name !== complaintImage.name);

        this._renderer.removeChild(this.image.nativeElement, li);
    }


    finish() {
        this._toastService.activate(this._languageService.instant('uspjesna_prijava_problema'));
        this._router.navigate(['/complaints/my-complaints']);
    }
}
